import OptionsFiltersActions from './constants';
import { IActionObject, IOptionsFilters } from './types';

const INITIAL_STATE: IOptionsFilters = {
  filterKey: null,
};

export default function optionsFiltersReducer(
  state = INITIAL_STATE,
  action: IActionObject
): IOptionsFilters {
  const { data } = action;
  switch (action.type) {
    case OptionsFiltersActions.SET_FILTER:
      return { ...state, [data.filterKey]: data.filterValue };
    case OptionsFiltersActions.CLEAR_FILTER:
      return { ...state, [data.filterKey]: null };
    case OptionsFiltersActions.CLEAR_FILTERS:
      Object.keys(state).map((key: any) => {
        // eslint-disable-next-line no-param-reassign
        state[key] = null;
        return null;
      });
      return state;
    default:
      return state;
  }
}
